export default __webpack_public_path__ + "static/media/buttons-search-default.afbae04d.svg";